fragment userInfo on User {
  email
  id
  role
  createdAt
  updatedAt
  allowedSites {
    id
  }
  company {
    id
    name
  }
}
